"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnidirectionalPresence = exports.useBidirectionalPresence = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _react = require("react");

var _subscriptionsTransportWs = require("subscriptions-transport-ws");

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _configment = _interopRequireDefault(require("@adc/configment"));

var _logger = _interopRequireDefault(require("@adc/logger"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var logger = _logger.default.forModule('@adc/presence');

var client = null;
var DEFAULT_OPTIONS = {
  // NOTE: The way this enable/disable is handled isn't great. I don't want to use a null component that renders the
  // hooks just to work around the rules of hooks. I'd like to find a better pattern where we can initialize and cleanup
  // all side effects internally properly. The way it's done now will allow us to toggle from not enabled when we aren't
  // mounted to enabled, but not to disable again (which might happen if we upsert new feature flags for some reason
  // that disabled, for example). An improvement for later when it becomes a problem.
  enabled: true
};

var initializeClient = _lodash.default.once(function () {
  client = new _subscriptionsTransportWs.SubscriptionClient(_configment.default.get('RESI_GRAPH_API_WS_URL_EXTERNAL') + '/graphql/subscriptions', {
    reconnectionAttempts: 20,
    reconnect: true
  }, WebSocket, 'adc-graphql-ws');
});

var StandardPresenceFragment = "\n  fragment StandardPresenceFragment on Presence {\n    members {\n      connected_at\n      last_updated_at\n      connection_id\n      is_current_user\n      context\n      identity {\n        __typename\n\n        ... on AnonymousMember {\n          anonymous_id\n        }\n\n        ... on AuthenticatedMember {\n          user_id\n          first_name\n          last_name\n        }\n      }\n    }\n  }\n";

var useBidirectionalPresence = function useBidirectionalPresence(channel, context) {
  var passedOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var opts = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), passedOpts);

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      currentPresence = _useState2[0],
      setPresence = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      gateOpen = _useState4[0],
      openGate = _useState4[1];

  (0, _react.useEffect)(function () {
    if (!opts.enabled) {
      return;
    }

    initializeClient(); // This is likely because the server forced us to close. The internals of this library will try to reconnect up to
    // the configured reconnection attempts so we will get new state quickly if everything is okay with the server.

    client.eventEmitter.on('disconnected', function () {
      setPresence({});
    });
    client.eventEmitter.on('connected', function () {
      openGate(function () {
        return true;
      });
      client.request({
        query: (0, _graphqlTag.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", "\n\n            subscription useBidirectionalPresence(\n              $channel: String!\n              $context: JSONObject!\n            ) {\n              trackBidirectionalPresence(channel: $channel, context: $context) {\n                ...StandardPresenceFragment\n              }\n            }\n          "])), StandardPresenceFragment),
        variables: {
          channel: channel,
          context: context
        }
      }).subscribe({
        error: function error(_error) {
          return logger.error(_error);
        },
        next: function next(_ref) {
          var data = _ref.data;
          if (!data) return;

          var presence = _lodash.default.get(data, 'trackBidirectionalPresence', {});

          if (_lodash.default.isEmpty(presence)) return;
          setPresence(presence);
        }
      });
    });
    return function () {
      return client.close();
    };
  }, [opts.enabled]);
  (0, _react.useEffect)(function () {
    if (!client || !opts.enabled) {
      return;
    }

    gateOpen && client.sendMessage(client.nextOperationId, 'GQL_CONTEXT_UPDATE', {
      context: context
    });
  }, [channel, context, opts.enabled]);
  return currentPresence;
};

exports.useBidirectionalPresence = useBidirectionalPresence;
var unidirectionalPresenceLogger = logger.forModule('presence:unidirectional');

var useUnidirectionalPresence = function useUnidirectionalPresence(channel, context) {
  var presenceOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var opts = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), presenceOptions);

  var _useState5 = (0, _react.useState)(function () {}),
      _useState6 = _slicedToArray(_useState5, 2),
      closeCurrentOperation = _useState6[0],
      setOperationCloser = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      updateSubscriptionContext = _useState8[0],
      setUpdateSubscriptionContext = _useState8[1];

  var graphWebsocket = opts.graphWebsocket;

  var configurePresenceOperation = function configurePresenceOperation(channel, context) {
    graphWebsocket.subscribe({
      operationOptions: {
        query: (0, _graphqlTag.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            subscription useUnidirectionalPresence(\n              $channel: String!\n              $context: JSONObject!\n            ) {\n              trackUnidirectionalPresence(channel: $channel, context: $context)\n            }\n          "]))),
        variables: {
          channel: channel,
          context: context
        }
      },
      onData: function onData(data) {
        unidirectionalPresenceLogger.info(data);
      },
      onError: function onError(error) {
        unidirectionalPresenceLogger.warn(error);
      }
    }).then(function (graphSubscriber) {
      setOperationCloser(function () {
        return graphSubscriber.unsubscribe;
      });
      setUpdateSubscriptionContext(function () {
        return graphSubscriber.updateContext;
      });
      return true;
    }).catch(function (err) {
      return unidirectionalPresenceLogger.warn(err);
    });
  };

  (0, _react.useEffect)(function () {
    if (!opts.enabled) {
      closeCurrentOperation === null || closeCurrentOperation === void 0 ? void 0 : closeCurrentOperation();
      return;
    }

    closeCurrentOperation === null || closeCurrentOperation === void 0 ? void 0 : closeCurrentOperation();

    if (!channel) {
      return;
    }

    configurePresenceOperation(channel, context);
  }, [channel, opts.enabled]);
  (0, _react.useEffect)(function () {
    updateSubscriptionContext === null || updateSubscriptionContext === void 0 ? void 0 : updateSubscriptionContext(context);
  }, [context, updateSubscriptionContext]);
};

exports.useUnidirectionalPresence = useUnidirectionalPresence;
